import './Header.css';

function Header() {
  ;
}

export default Header;
